export const mutations = {
  setDriverLogs(state, driverLogs) {
    state.driverLogs = driverLogs;
  },
};
